<template>
  <div>
       <!--采购历史-->
      <header class="form-title">
          <Row>
              <Col span="22">
                  <Form  inline  :label-width="80" >
                      <FormItem  label="选择时间">
                          <DatePicker
                                  split-panels
                                  type="daterange"
                                  :options="options"
                                  placeholder="选择日期"
                                  @on-change="modifyTime"
                                  :value="valuedate"
                                  >
                          </DatePicker>
                      </FormItem>
                      <FormItem  label="调拨类型">
                          <Select v-model="type" class="formSelect-input" style="width: 200px" >
                              <Option value="" >全部</Option>
                              <Option value="0" >调入单</Option>
                              <Option value="1" >调出单</Option>
                          </Select>
                          <Button type="primary" style="margin-left: 15px" @click="searchCondition">搜索</Button>
                      </FormItem>
                  </Form>
             </Col>
          </Row>
      </header>
      <section>
          <Alert v-if="pageData==''" align="center">暂无数据</Alert>
          <Card class="historyItem" :dis-hover="false" v-for="(item, index) in pageData" :key="index" @click.native="$router.push({path:'/allocahisdetail',query:{id:item.id}})">
              <p slot="title" style="color: #ffaf5e;" v-if="item.type==1">{{item.adminName}}</p>
              <p slot="title" style="color: #46bab2;" v-if="item.type==0">{{item.adminName}}</p>
              <span slot="extra" class="typeitem typeitems" v-if="item.type==1">调出单</span>
              <span slot="extra" class="typeitem" v-if="item.type==0">调入单</span>
              <ul class="type-content">
                  <li  v-if="item.type==0">  调出店铺： {{item.comename}} </li>
                  <li  v-if="item.type==1">  调入店铺： {{item.comename}} </li>
                  <li>  单号：{{item.code}} </li>
                  <li>  建立时间：{{item.time}} </li>
              </ul>
              <p style="text-align: right" class="yiche" v-if="item.status==1">已撤销</p>
          </Card>
      </section>
      <div class="pageTotal"   v-if="pageData!=''">
          <Page :total="page.total"
                show-total
                :page-size="page.rows"
                @on-change="onGongPageTotal" />
      </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
        cid:'',
        sid:'',
        pageData:{},
        options: {
            shortcuts: [
                {
                    text: '昨日',
                    value () {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 *1);
                        return [start, start];
                    },
                },
                {
                    text: '今日',
                    value () {
                        const end = new Date();
                        const start = new Date();
                        return [start, end];
                    },
                },
                {
                    text: '近七日',
                    value () {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        return [start, end];
                    },

                }
            ],
        },
        sendData:{
            code:'',
        },
        type:'',
        page:{
            total:0,
            page:1,
            rows:12
        }
    };
  },
    created: function() {
        //获取用户信息
        this.cid= JSON.parse(localStorage.getItem('shop')).cid
        this.sid = JSON.parse(localStorage.getItem('shop')).id
        this.valuedate[0] = this.fun_date(-30)
        this.valuedate[1] = this.nowTime
        this.selectInventory(this.page.page,this.page.rows,this.valuedate[0],this.valuedate[1])
    },
    watch: {
        'type': {
            deep: true,
            handler: function (newVal, oldVal) {
                this.selectInventory(this.page.page,this.page.rows,this.valuedate[0],this.valuedate[1])
            }
        },
    },
  methods: {

      //获取采购单
      selectInventory(page,rows,startTime,endTime){
          this.$Api.selectInventory({
              cid: this.cid,
              sid: this.sid,
              page: page,
              rows: rows,
              time: startTime,
              endtime:endTime,
              type: this.type,
          }).then(res => {
              if(res.code==200){
                  this.page.total = res.count
                  this.pageData = res.data
              }else {
                  this.$Message.warning(res.msg);
              }
          });

      },

      modifyTime(time){
          this.valuedate[0]=time[0]
          this.valuedate[1]=time[1]
          this.selectInventory(this.page.page,this.page.rows,this.valuedate[0],this.valuedate[1])
      },
      onGongPageTotal(num){
          this.selectInventory(num,this.page.rows,this.valuedate[0],this.valuedate[1])
      },
      searchCondition(){
          this.selectInventory(this.page.page,this.page.rows,this.valuedate[0],this.valuedate[1])
      },
  }
};
</script>

<style lang="scss" scoped>
  .form-title{
    line-height: 54px;
    border-bottom: 1px solid #d9d9d9;
    margin-bottom: 20px;
  }
.historyItem{
    width: 450px;
    height: 190px;
    background-color: #ffffff;
    box-shadow: 0px 3px 10px 0px
    rgba(24, 54, 129, 0.14);
    border-radius: 10px;
    display: inline-block;
    margin: 14px;
    cursor: pointer;
    position: relative;
    .yiche{
        position: absolute;
        right: 20px;
        bottom: 20px;
    }
    .typeitem{
        display: block;
        width: 60px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        background-color: #e5fff7;
        border-radius: 4px;
        border: solid 1px #46bab2;
        position: relative;
        top: -3px;
        right: -3px;
        color: #46bab2;
    }
    .type-content{
        li{
            height: 30px;
        }
    }
    .typeitems{
        background-color: #fff2e5;
        border: solid 1px #ffaf5e;
        color: #ffaf5e;
    }
}
</style>